export default {
	all: '',
	status: {
		approved: '',
		'in-preparation': '',
		shipping: '',
		delivered: '',
		paid: '',
		unpaid: '',
		canceled: ''
	},
	'order-status': ''
}